module.exports = __webpack_public_path__ + "assets/images/icon-close.svg?v=bdde5dd1";